export default "__VITE_ASSET__DJBklH77__"